"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthApiOperations = void 0;
var AuthApiOperations;
(function (AuthApiOperations) {
    AuthApiOperations[AuthApiOperations["GenerateRecoveryCodes"] = 0] = "GenerateRecoveryCodes";
    AuthApiOperations[AuthApiOperations["GetRecoveryKeyParams"] = 1] = "GetRecoveryKeyParams";
    AuthApiOperations[AuthApiOperations["SignInWithRecoveryCodes"] = 2] = "SignInWithRecoveryCodes";
})(AuthApiOperations || (exports.AuthApiOperations = AuthApiOperations = {}));
